module.exports = __webpack_public_path__ + "static/media/google-calendar-icon.3858bb27.svg";